import React from 'react';
import Heading from '@atlaskit/heading';
import { Anchor, Stack, Text, xcss } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const Header = () => {
	const { formatMessage } = useIntl();
	return (
		<Stack space="space.100">
			<Heading size="large" as="h1">
				{formatMessage(messages.widgetSettingsTitle)}
			</Heading>
			<Text testId="servicedesk-widget-settings.ui.header.widget-subtitle">
				<FormattedMessage
					{...(fg('virtual_agent_rebrand_to_virtual_service_agent')
						? messages.widgetSettingsDescriptionV2
						: messages.widgetSettingsDescription)}
					values={{
						br: <br />,
						a: (chunks) => (
							<Anchor
								href="https://support.atlassian.com/jira-service-management-cloud/docs/collect-requests-from-anywhere-with-an-embeddable-widget/"
								target="_blank"
								xcss={configureLinkStyles}
							>
								{chunks}
							</Anchor>
						),
					}}
				/>
			</Text>
		</Stack>
	);
};

const configureLinkStyles = xcss({
	color: 'color.link',
	textDecoration: 'none',

	':hover': {
		color: 'color.link.pressed',
		textDecoration: 'underline',
	},
});
